import { QueryResult } from '@apollo/client'
import { GetDsTypesQuery, useGetDsTypesQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetDsTypesQueryResult = QueryResult<GetDsTypesQuery>
export type DSType = GetDsTypesQuery['dsTypes']['records'][0]

const { Provider, useContextFn } = createStrictContext<{
  records: DSType[]
  refetch: GetDsTypesQueryResult['refetch']
  fetching: GetDsTypesQueryResult['loading']
}>('TypesTableContext')

export const useTypesTableContext = useContextFn

export const TypesTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetDsTypesQuery({
    ...DefaultQueryHookOptions,
    variables: {
      dsTypeListInput: {
        projectId: { equals: projectId },
      },
    },
  })
  return (
    <Provider
      value={{
        records: data?.dsTypes?.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
